module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/theTrip_2x.71eab99.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/theTrip_2x.png
// module id = VOPr
// module chunks = 41